import { Context, useContext } from 'react';

export function useSafeContext<T>(hook: Function, contextType: Context<T | undefined>) {
  const context = useContext(contextType);

  if (!context) throw new Error(`${hook.name} must be used within a ${contextType.displayName}`);

  return context;
}
